import React from 'react';

function NotFound() {
  // You can add content and functionality to your NotFound here

  return (
    <div>
      <h2>Pas trouvé</h2>
      {/* Add your NotFound components and content here */}
    </div>
  );
}

export default NotFound;
